import Model, { attr, belongsTo } from '@ember-data/model';

export default class RegisterDocument extends Model {
  @attr contentType;
  @attr('string') docType;
  @attr('string') docSubtype;
  @attr('string') subjectId;
  @attr('string') subjectType;
  @attr('string') name;
  @attr size;
  @attr('string') url;
  @attr('files') files;

  @belongsTo('register-stakeholder', { async: false, inverse: 'documents' }) stakeholder;
  @belongsTo('register-organization', { async: false, inverse: 'documents' }) organization;
}
